import { getSessionStorageItem, setSessionStorageItem } from 'in-meeting-experience-ui-components/utils/sessionStotage';
import { FAKE_MEETING_UUID_STORAGE_KEY } from '../constants/google-meet';
export const isIframe = window !== window.parent;
export const getGeneratedMeetingUUID = meetingId => {
  const savedUUID = getSessionStorageItem(FAKE_MEETING_UUID_STORAGE_KEY);
  if (savedUUID) return savedUUID;
  const fakeUUID = `${meetingId}${Date.now()}`;
  setSessionStorageItem(FAKE_MEETING_UUID_STORAGE_KEY, fakeUUID);
  return fakeUUID;
};